import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { AuthService } from '@/services/AuthService'

import 'primeicons/primeicons.css'
import './assets/styles/global.css'

const app = createApp(App)

app.use(router)

const bootstrap = async () => {
    try {
        await AuthService.bootstrapAuth()
    } catch (err) {
        console.error('[Auth bootstrap failed]', err)
        await AuthService.clearSession?.()
    } finally {
        app.mount('#app')
    }
}

bootstrap()
